module.exports = __webpack_public_path__ + "static/media/griffith-residence.2945d2fa.png";